import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import _ from 'lodash';
import axios from 'axios';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';
import { Divider,
  Icon,
  Message,
  Form,
  Input,
  Container,
  Card,
  Image,
  Label,
  Checkbox,
  Table,
  Button } from 'semantic-ui-react';

const TELEGRAM_API_BASE_URL = 'https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production';
const TELEGRAM_CHATS_API = `${TELEGRAM_API_BASE_URL}/telegram/chats`;

const noPadding = {
  padding: 0,
};

const noBorder = {
  border: 'none',
  'box-shadow': 'none',
};

const marginAuto = {
  margin: 'auto',
};

const previewBlockStyle = {
  color: '#666666',
  minHeight: 350,
  height: 'auto',
};

const previewIconStyle = {
  marginTop: 150,
};

const modalSizeStyle = {
  height: 500,
};

const tableSizeStyle = {
  maxHeight: 200,
  overflow: 'scroll',
};

const cf = num => numeral(num).format('0,0');

class TelegramChannelAddModal extends React.Component {
  constructor() {
    super();
    this.state = {
      isPublic: true,
      telegramChats: [],
      mode: 'public',
    };
  }

  async componentDidMount() {
    console.log('get all telegram chats');
    const chatsUrl = `${TELEGRAM_CHATS_API}`;
    console.log(chatsUrl);
    const response = await axios.get(chatsUrl);
    const { data: { data } } = response;
    await this.setState({
      telegramChats: _.get(data, 'formattedChats'),
    });
  }

  togglePublic = () => {
    const { isPublic } = this.state;
    const newValue = !isPublic;
    this.setState({
      isPublic: newValue,
    });
  }

  switchMode = mode => {
    this.setState({
      mode,
    });
  }

  render() {
    const {
      onClose,
      isLoading,
      isAddingChannel,
      handleAddChannel,
      handleAddPrivateChannel,
      isDuplicateChannel,
      telegramUrl,
      searchTelegramChannel,
      hasError,
      channelData,
      type,
    } = this.props;

    const { mode, telegramChats } = this.state;

    const openGraph = _.get(channelData, 'ogResponse.openGraph');
    const typeInfo = _.get(channelData, 'typeInfo');
    console.log(openGraph);
    console.log(channelData);
    console.log(type);
    console.log(typeInfo);
    console.log(mode);
    const actionButtonIcon = isAddingChannel ? <Icon name="spinner" loading /> : <Icon name="add" />;

    const channelAdded = true;

    const mismatch = (((type === 'USER' && _.get(typeInfo, 'type') && _.get(typeInfo, 'type') !== type)
    || (type !== 'USER' && _.get(typeInfo, 'type') === 'USER')));

    return (
      <DyzioModal
        onClose={onClose}
        onActionButtonClick={handleAddChannel}
        hasActionButton
        actionButtonContent={`Add Telegram ${_.capitalize(type)}`}
        actionButtonIcon={actionButtonIcon}
        shouldDisableActionButton={mismatch || isAddingChannel || isLoading}
        headerText={`Add a new Telegram ${_.capitalize(type)}`}
        size="small"
        style={modalSizeStyle}
      >
        <Card fluid style={noBorder}>
          <Card.Content style={marginAuto}>
            <Button.Group>
              <Button onClick={() => this.setState({ mode: 'public' })} positive={mode === 'public'}>Public</Button>
              <Button.Or />
              <Button onClick={() => this.setState({ mode: 'private' })} positive={mode === 'private'}>Private</Button>
            </Button.Group>
          </Card.Content>
        </Card>
        { isDuplicateChannel &&
        <Message fluid error>
          This asset has already been added to the campaign.
        </Message>
        }
        { mismatch &&
        <Message
          error
          header="Telegram type mismatch"
          content={`${type === 'USER' ? '' : 'Non-'}User is expected`}
        />}
        { mode === 'public' &&
        <Card fluid style={noBorder}>
          <Form onSubmit={handleAddChannel}>
            <Form.Field>
              <Input
                fluid
                value={telegramUrl}
                label="URL"
                labelPosition="left"
                style={noPadding}
                onChange={searchTelegramChannel}
              />
            </Form.Field>
            <Divider />
            <Form.Field>
              <Container textAlign="center" style={previewBlockStyle}>
                { hasError && <div>
                  <Icon name="minus circle" size="huge" style={previewIconStyle} />
                  <br />
                  <span>
                    <b>invalid url.</b>
                  </span>
                </div>
                }
                { !channelData && <div>
                  <Icon
                    loading={isLoading}
                    name={'arrow alternate circle up outline'} size="huge" style={previewIconStyle}
                  />
                  <br />
                  <span>
                    <b>
                      { isLoading ? 'please wait...' : 'paste Telegram Channel url above' }
                    </b>
                  </span>
                </div>
                }

                {
                  openGraph &&
                  <Card.Group>
                    <Card centered>
                      <Card.Content>
                        <Image
                          size="small"
                          src={openGraph.image.url}
                          className="circular"
                        />
                        <Divider />
                        <h2>
                          {openGraph.title}
                        </h2>
                        <h4>
                          <Label basic color="blue">{typeInfo.type}</Label>
                        </h4>
                        {
                          typeInfo.followers &&
                          <h3 style={{ padding: 10 }}>
                            {cf(typeInfo.followers)} {typeInfo.type.match(/GROUP/) ? 'members' : 'subscribers'}
                          </h3>
                        }
                        <p>
                          {openGraph.description}
                        </p>
                        <div style={{ paddingBottom: 10 }}>
                          <a
                            href={`${'https://t.me'}/${channelData.channelUrl}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >{channelData.channelUrl}</a>
                        </div>
                      </Card.Content>
                    </Card>
                  </Card.Group>
                }

              </Container>
            </Form.Field>
          </Form>
        </Card> }

        { mode === 'private' && <Card fluid style={noBorder}>
          <Card.Content>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>System Account</Table.HeaderCell>
                  <Table.Cell>moonboots_socials</Table.Cell>
                </Table.Row>
              </Table.Header>
            </Table>
          </Card.Content>
          <Card.Content>
            choose private group/channel from the list below.
            If the group/channel is not in the list then ask your KOL to invite
            @moonboots_socials to the group. help link.
          </Card.Content>
          <Card.Content>
            <Table style={tableSizeStyle}>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Username</Table.HeaderCell>
                  <Table.HeaderCell>Header</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {
                  _.map(telegramChats, chat => {
                    const { title, username } = chat;
                    return (<Table.Row>
                      <Table.Cell>
                        <Label>{title}</Label>
                      </Table.Cell>
                      <Table.Cell>{username}</Table.Cell>
                      <Table.Cell>
                        <Button
                          color="pink"
                          inverted
                          icon="plus"
                          content="Add Channel"
                          onClick={() => handleAddPrivateChannel(chat)}
                        />
                      </Table.Cell>
                    </Table.Row>);
                  })
                }
              </Table.Body>
            </Table>
          </Card.Content>
        </Card>}
      </DyzioModal>
    );
  }
}

TelegramChannelAddModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isAddingChannel: PropTypes.bool.isRequired,
  isDuplicateChannel: PropTypes.bool.isRequired,
  handleAddChannel: PropTypes.func.isRequired,
  handleAddPrivateChannel: PropTypes.func.isRequired,
  telegramUrl: PropTypes.string.isRequired,
  searchTelegramChannel: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  channelData: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
};

export default TelegramChannelAddModal;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-profile-stats/components/telegram-channel-add.js
 **/